import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\GetInvoiceActivitiesByIdController::__invoke
* @see app/Http/Controllers/Invoice/GetInvoiceActivitiesByIdController.php
* @route '/api/invoice/{invoice}/activities'
*/
const GetInvoiceActivitiesByIdController = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetInvoiceActivitiesByIdController.url(args, options),
    method: 'get',
})

GetInvoiceActivitiesByIdController.definition = {
    methods: ["get","head"],
    url: '/api/invoice/{invoice}/activities',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Invoice\GetInvoiceActivitiesByIdController::__invoke
* @see app/Http/Controllers/Invoice/GetInvoiceActivitiesByIdController.php
* @route '/api/invoice/{invoice}/activities'
*/
GetInvoiceActivitiesByIdController.url = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invoice: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { invoice: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
    }

    return GetInvoiceActivitiesByIdController.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\GetInvoiceActivitiesByIdController::__invoke
* @see app/Http/Controllers/Invoice/GetInvoiceActivitiesByIdController.php
* @route '/api/invoice/{invoice}/activities'
*/
GetInvoiceActivitiesByIdController.get = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetInvoiceActivitiesByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Invoice\GetInvoiceActivitiesByIdController::__invoke
* @see app/Http/Controllers/Invoice/GetInvoiceActivitiesByIdController.php
* @route '/api/invoice/{invoice}/activities'
*/
GetInvoiceActivitiesByIdController.head = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetInvoiceActivitiesByIdController.url(args, options),
    method: 'head',
})

export default GetInvoiceActivitiesByIdController